const LinkGoToIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='currentColor'
		height='12'
		viewBox='0 0 12 12'
		width='12'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M1.60039 11.5999C1.27039 11.5999 0.98789 11.4824 0.75289 11.2474C0.517891 11.0124 0.400391 10.7299 0.400391 10.3999V1.5999C0.400391 1.2699 0.517891 0.987403 0.75289 0.752403C0.98789 0.517403 1.27039 0.399902 1.60039 0.399902H6.00039V1.5999H1.60039V10.3999H10.4004V5.9999H11.6004V10.3999C11.6004 10.7299 11.4829 11.0124 11.2479 11.2474C11.0129 11.4824 10.7304 11.5999 10.4004 11.5999H1.60039ZM4.45039 8.3999L3.60039 7.5499L9.55039 1.5999H7.60039V0.399902H11.6004V4.3999H10.4004V2.4499L4.45039 8.3999Z'
			fill='currentColor'
		/>
	</svg>
)

export { LinkGoToIcon }
